import React from 'react';
import { Header, Tab } from 'semantic-ui-react';
import MenuLinksTable from '../form/menuLink/MenuLinkTable';
import MenuCategoriesTable from '../form/menuCategory/MenuCategory';

const HeaderMenu = ({ data }) => {
  const categoriesByLocale = {
    fr: data.categoriesDetails.filter(
      (category) => category.language_code === 'fr',
    ),
    en: data.categoriesDetails.filter(
      (category) => category.language_code === 'en',
    ),
  };
  const linksByLocale = {
    fr: categoriesByLocale.fr.map((category) => ({
      categoryName: category.name,
      linksDetails: category.linksDetails,
    })),
    en: categoriesByLocale.en.map((category) => ({
      categoryName: category.name,
      linksDetails: category.linksDetails,
    })),
  };

  return (
    <div>
      <Header as="h1">Navigation principale</Header>
      <Header as="h2">Catégories</Header>
      <Tab
        panes={[
          {
            menuItem: 'Français',
            render: () => (
              <Tab.Pane key="categories-fr">
                <MenuCategoriesTable categories={categoriesByLocale.fr} />
              </Tab.Pane>
            ),
          },
          {
            menuItem: 'Anglais',
            render: () => (
              <Tab.Pane key="categories-en">
                <MenuCategoriesTable categories={categoriesByLocale.en} />
              </Tab.Pane>
            ),
          },
        ]}
      />
      <Header as="h2">Liens</Header>
      <Tab
        panes={[
          {
            menuItem: 'Français',
            render: () => (
              <Tab.Pane key="links-en">
                <MenuLinksTable
                  color="purple"
                  items={linksByLocale.fr}
                  isHeaderMenu
                />
              </Tab.Pane>
            ),
          },
          {
            menuItem: 'Anglais',
            render: () => (
              <Tab.Pane key="links-en">
                <MenuLinksTable
                  color="purple"
                  items={linksByLocale.en}
                  isHeaderMenu
                />
              </Tab.Pane>
            ),
          },
        ]}
      />
    </div>
  );
};

const FooterMenu = ({ data }) => {
  const linksByLocale = {
    fr: data.linksDetails.filter((link) => link.language_code === 'fr'),
    en: data.linksDetails.filter((link) => link.language_code === 'en'),
  };

  return (
    <div>
      <Header as="h1">Navigation Footer</Header>
      <Header as="h2">Liens</Header>
      <Tab
        panes={[
          {
            menuItem: 'Français',
            render: () => (
              <Tab.Pane key="links-fr">
                <MenuLinksTable color="purple" items={linksByLocale.fr} />
              </Tab.Pane>
            ),
          },
          {
            menuItem: 'Anglais',
            render: () => (
              <Tab.Pane key="links-en">
                <MenuLinksTable color="purple" items={linksByLocale.en} />
              </Tab.Pane>
            ),
          },
        ]}
      />
    </div>
  );
};

const Menus = ({ data, type }) => {
  if (type === 'HEADER') {
    return <HeaderMenu data={data} />;
  } else if (type === 'FOOTER') {
    return <FooterMenu data={data} />;
  }
  return null;
};

export default Menus;



// WEBPACK FOOTER //
// ./src/components/list/Menus.js